module.exports = __webpack_public_path__ + "img/beijing4.e3e96e62.jpeg";